<script setup lang="ts">
import { useCategoryTranslateSetup } from '@/utils/composables/useCategoryTranslate/useCategoryTranslate';

useCategoryTranslateSetup();
</script>

<template>
  <div />
</template>
